import { message } from "antd";
import axiosInstance from "../axiosInstance";
import { PAGE_SIZE } from "../constants";

import {
	CREATE_SPIN_REWARD_REQUEST,
	CREATE_SPIN_REWARD_SUCCESS,
	CREATE_SPIN_REWARD_FAIL,
	RESET_DELETE_SPIN_REWARD,
	FETCH_SPIN_REWARDS_REQUEST,
	FETCH_SPIN_REWARDS_SUCCESS,
	FETCH_SPIN_REWARDS_FAIL,
	UPDATE_SPIN_REWARD_REQUEST,
	UPDATE_SPIN_REWARD_SUCCESS,
	UPDATE_SPIN_REWARD_FAIL,
	DELETE_SPIN_REWARD_REQUEST,
	DELETE_SPIN_REWARD_SUCCESS,
	DELETE_SPIN_REWARD_FAIL,
	FETCH_SPIN_REWARD_REQUEST,
	FETCH_SPIN_REWARD_SUCCESS,
	FETCH_SPIN_REWARD_FAIL,
} from "../constants/spinTheWheelReward";

const createSpinReward = (values) => async (dispatch, getState) => {
	const {
		login: { adminInfo },
	} = getState();
	dispatch({ type: CREATE_SPIN_REWARD_REQUEST });
	try {
		const { data } = await axiosInstance.post("/admin/rewards", values, {
			headers: {
				Authorization: "Bearer " + adminInfo.authToken,
			},
		});
		message.success("Created.");
		dispatch(fetchSpinRewards({ start: 0, count: PAGE_SIZE }));
		dispatch({
			type: CREATE_SPIN_REWARD_SUCCESS,
			payload: data,
		});
	} catch (error) {
		const errorMessage = error.response.data.error;
		message.error(errorMessage);
		dispatch({ type: CREATE_SPIN_REWARD_FAIL, payload: errorMessage });
	}
};

const fetchSpinRewards = (params) => async (dispatch, getState) => {
	const {
		login: { adminInfo },
	} = getState();

	dispatch({ type: FETCH_SPIN_REWARDS_REQUEST });
	try {
		const { data } = await axiosInstance.get("/admin/rewards", {
			params,
			headers: {
				Authorization: "Bearer " + adminInfo.authToken,
			},
		});

		dispatch({
			type: FETCH_SPIN_REWARDS_SUCCESS,
			payload: data,
		});
	} catch (error) {
		console.log("error: ", error);
		const errorMessage = error.response.data.error;
		dispatch({ type: FETCH_SPIN_REWARDS_FAIL, payload: errorMessage });
	}
};

const resetDeleteStatusSpinReward = () => async (dispatch) => {
	dispatch({ type: RESET_DELETE_SPIN_REWARD });
};

const updateSpinReward = (id, values) => async (dispatch, getState) => {
	const {
		login: { adminInfo },
	} = getState();
	dispatch({ type: UPDATE_SPIN_REWARD_REQUEST });
	try {
		const { data } = await axiosInstance.patch(`/admin/rewards/${id}`, values, {
			headers: {
				Authorization: "Bearer " + adminInfo.authToken,
			},
		});

		message.success("Updated.");
		dispatch({
			type: UPDATE_SPIN_REWARD_SUCCESS,
			payload: data,
		});
	} catch (error) {
		const errorMessage = error.response.data.error;
		message.error(errorMessage);
		dispatch({ type: UPDATE_SPIN_REWARD_FAIL, payload: errorMessage });
	}
};

const deleteSpinReward = (id) => async (dispatch, getState) => {
	const {
		login: { adminInfo },
	} = getState();
	dispatch({ type: DELETE_SPIN_REWARD_REQUEST });
	try {
		const { data } = await axiosInstance.delete(`/admin/rewards/${id}`, {
			headers: {
				Authorization: "Bearer " + adminInfo.authToken,
			},
		});

		message.success("Deleted.");
		dispatch({
			type: DELETE_SPIN_REWARD_SUCCESS,
			payload: data,
		});
	} catch (error) {
		const errorMessage = error.response.data.error;
		message.error(errorMessage);
		dispatch({ type: DELETE_SPIN_REWARD_FAIL, payload: errorMessage });
	}
};

const fetchSpinReward = (id) => async (dispatch, getState) => {
	const {
		login: { adminInfo },
	} = getState();
	dispatch({ type: FETCH_SPIN_REWARD_REQUEST });

	try {
		const { data } = await axiosInstance.get(`/admin/rewards/${id}`, {
			headers: {
				Authorization: "Bearer " + adminInfo.authToken,
			},
		});

		dispatch({ type: FETCH_SPIN_REWARD_SUCCESS, payload: data.data });
	} catch (error) {
		console.log("error: ", error);
		const errorMessage = error.response.data.error;
		message.error(errorMessage);
		dispatch({ type: FETCH_SPIN_REWARD_FAIL, payload: errorMessage });
	}
};

export {
	createSpinReward,
	resetDeleteStatusSpinReward,
	fetchSpinRewards,
	updateSpinReward,
	deleteSpinReward,
	fetchSpinReward,
};
